import PropTypes from 'prop-types';
import React from 'react';

import ProfitAndLossPageFrame from '../../ProfitAndLoss/components/PageFrame';
import { offerPath } from '../../Settlement/actions/settlementActionCreators';

const PageFrame = ({
  csrfToken,
  team,
  currentUser,
  confirm,
  onConfirmChanged,
  showPageFrame,
  children,
  offerId,
  editOfferPath,
  isSettling,
  requestFormat,
  isSaving,
  isV3
}) => {
  const links = isSettling ? [
    {
      href: offerPath(isV3, team, offerId, "/settlement.pdf"),
      icon: "far fa-file-pdf",
      label: "Download PDF"
    },
    ...(!isV3 ? [{
      href: `/teams/${team.id}/offers/${offerId}/settlement.csv`,
      icon: "far fa-file-csv",
      label: "Download CSV"
    }] : [])
  ] : [
    ...(currentUser?.can_manage_offers ? [{
      href: editOfferPath || offerPath(isV3, team, offerId, "/edit"),
      icon: "far fa-pencil",
      label: "Edit Offer",
      target: "_self"
    }] : []),
    {
      href: offerPath(isV3, team, offerId, "/preview.pdf"),
      icon: "far fa-file-pdf",
      label: "Download PDF"
    }
  ];

  return (
    <ProfitAndLossPageFrame
      csrfToken={csrfToken}
      team={team}
      currentUser={currentUser}
      confirm={confirm}
      onConfirmChanged={onConfirmChanged}
      showPageFrame={showPageFrame}
      downloadLinks={links}
      titleAccessory={!isSettling && requestFormat === "html" && confirm.id ? (
        <a href={`/teams/${team.id}/confirms/${confirm.id}`}
            className='ml-3'
            style={{"fontSize": "14px", "fontWeight": "600"}}>
          Go to Event Details <i className="fas fa-arrow-right"></i>
        </a>
      ) : null}
      headerAside={isSettling && requestFormat === "html" ? (
        <div className="col-12 col-md-auto d-flex justify-content-end align-items-end"
              style={{"paddingRight": "15px"}}>
          <p style={{"fontSize": "14px", "textAlign": "right", "display": "inline-block", "float": "right", "color": "var(--od-c-a4a7ae, rgba(58, 58, 58, 0.5))"}}>
            {isSaving ? (
              <span>
                <i aria-hidden className="far fa-sync fa-rotate-90" style={{"marginRight": "6px"}}></i>
                Automatically saving changes
              </span>
            ) : (
              <span>
                <i aria-hidden className="far fa-check-circle" style={{"marginRight": "6px"}}></i>
                Changes automatically saved
              </span>
            )}
          </p>
        </div>
      ) : null}
    >
      {children}
    </ProfitAndLossPageFrame>
  );
};

PageFrame.propTypes = {
  csrfToken: PropTypes.string,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object,
  confirm: PropTypes.object,
  onConfirmChanged: PropTypes.func,
  showPageFrame: PropTypes.bool,
  children: PropTypes.element.isRequired,
  offerId: PropTypes.string,
  editOfferPath: PropTypes.string,
  isSettling: PropTypes.bool,
  requestFormat: PropTypes.string,
  isSaving: PropTypes.bool,
  isV3: PropTypes.bool
};

export default PageFrame;
